import React from 'react'

export default function StatusPill({ active, activeText = 'Active', inactiveText = 'Inactive' }) {
  return (
    <span className={`inline-flex items-center px-3 py-1 rounded-md text-xs font-medium ${active ? 'bg-success bg-opacity-10 text-success' : 'bg-danger bg-opacity-10 text-danger'}`}>
      <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${active ? 'bg-success' : 'bg-danger'}`} />
      {active ? activeText : inactiveText}
    </span>
  )
}
